<mat-form-field appearance="outline">
  <mat-label>{{
    isAdding ? ("ONSIP_I18N.TOPIC_NAME" | translate) : ("ONSIP_I18N.CHANGE_TOPIC_NAME" | translate)
  }}</mat-label>
  <input
    #input
    matInput
    [placeholder]="'ONSIP_I18N.TOPIC_NAME' | translate"
    maxlength="24"
    autocomplete="off"
    [formControl]="formControl"
  />
  <mat-hint align="end">{{ input.value.length }} / 24</mat-hint>
  <mat-error>{{ getErrors() }}</mat-error>
</mat-form-field>
